import axios, {AxiosResponse} from "axios";
import {$api, getEnvApi} from "../../api";
import {ILogin, ILoginResponse} from "../../types/ILogin";


export class AuthService {
    static async login(body: ILogin): Promise<AxiosResponse<ILoginResponse>> {
        return $api.post<ILoginResponse>(`${getEnvApi()}api/token/`, body)
    }
    static async refresh(): Promise<AxiosResponse<ILoginResponse>> {
        return axios.post<ILoginResponse>(`${getEnvApi()}api/token/refresh/`, {
            refresh: localStorage.getItem('refresh_token')
        })
    }

}
